<div class="form-viewer">
  <div>
    <gstar-template-factory />
  </div>
</div>
